import React from 'react';

function ServicesSection() {
  const slides = [
    {
      num: '.01',
      image: '/service1.jpg',
      imageAlt: 'Precast & Cast-In-Situ Piling',
      title: 'PRECAST & CAST-IN-SITU PILING SOLUTIONS',
      desc: 'Offering specialized piling techniques tailored to diverse soil conditions and project requirements. Using cutting-edge machinery and proven methodologies, we guarantee deep foundation integrity and performance.'
    }
  ];

  const [currentIndex, setCurrentIndex] = React.useState(0);
  const total = slides.length;

  const goPrev = function () {
    setCurrentIndex(function (i) { return (i - 1 + total) % total; });
  };
  const goNext = function () {
    setCurrentIndex(function (i) { return (i + 1) % total; });
  };

  const slide = slides[currentIndex];

  const styles = {
    section: { padding: '80px 48px 80px', background: '#fff', width: '100%', maxWidth: 1920, boxSizing: 'border-box', margin: '0 auto' },
    offerRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      marginBottom: 8
    },
    offerLine: { width: 40, height: 3, background: '#E73123' },
    offerText: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textAlign: 'center', textTransform: 'uppercase',
      color: '#333'
    },
    titleRow: { textAlign: 'center', marginBottom: 48 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123'
    },
    titleBlack: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#1a1a1a'
    },
    contentWrap: {
      display: 'flex', position: 'relative', width: '100%', maxWidth: 1920,
      margin: '0 auto', minHeight: 600, overflow: 'hidden', flexWrap: 'wrap'
    },
    imageWrap: { width: '50%', minWidth: 300, height: 600, flexShrink: 0, position: 'relative' },
    serviceImage: { width: '100%', height: 600, objectFit: 'cover', opacity: 1 },
    darkBlock: {
      flex: '1 1 50%', minWidth: 300, position: 'relative', top: 0, height: 600,
      background: '#1a1a1a', padding: '48px 40px', display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', opacity: 1
    },
    darkBlockInner: {
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      maxWidth: 480, width: '100%', margin: '0 auto', textAlign: 'center'
    },
    serviceNum: {
      fontFamily: 'Lato', fontWeight: 800, fontSize: '84px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase',
      color: '#FFFFFF', margin: '0 0 16px'
    },
    serviceTitle: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '26px', lineHeight: '38px',
      letterSpacing: 0, textTransform: 'uppercase', color: '#FFFFFF', margin: '0 0 24px',
      textAlign: 'center', width: '100%'
    },
    serviceDesc: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '24px', lineHeight: '38px',
      letterSpacing: 0, color: '#FFFFFF', margin: '0 0 32px',
      textAlign: 'center', width: '100%'
    },
    exploreBtn: {
      display: 'inline-block', padding: '14px 40px', border: '2px solid #FFFFFF',
      color: '#FFFFFF', textDecoration: 'none', fontFamily: 'Lato', fontWeight: 400,
      fontSize: '18px', textTransform: 'uppercase', alignSelf: 'center'
    },
    arrowLeft: {
      position: 'absolute', left: 24, bottom: 24, zIndex: 10,
      width: 56, height: 56, borderRadius: 8, background: '#E73123',
      border: 'none', color: '#fff', cursor: 'pointer', display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 300
    },
    arrowRight: {
      position: 'absolute', right: 24, bottom: 24, zIndex: 10,
      width: 56, height: 56, borderRadius: 8, background: '#E73123',
      border: 'none', color: '#fff', cursor: 'pointer', display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 300
    }
  };

  return React.createElement('section', { style: styles.section, className: 'services-section-home' },
    React.createElement('div', { style: styles.offerRow },
      React.createElement('div', { style: styles.offerLine }),
      React.createElement('span', { style: styles.offerText }, 'WHAT WE OFFER'),
      React.createElement('div', { style: styles.offerLine })
    ),
    React.createElement('div', { style: styles.titleRow, className: 'services-title-row' },
      React.createElement('span', { style: styles.titleRed }, 'SERVICES '),
      React.createElement('span', { style: styles.titleBlack }, 'WE PROVIDE')
    ),
    React.createElement('div', { style: styles.contentWrap, className: 'services-content-wrap' },
      React.createElement('div', { style: styles.imageWrap, className: 'services-image-wrap' },
        React.createElement('img', {
          src: slide.image,
          alt: slide.imageAlt,
          style: styles.serviceImage,
          key: currentIndex
        }),
        React.createElement('button', { type: 'button', style: styles.arrowLeft, onClick: goPrev, 'aria-label': 'Previous service' }, '‹')
      ),
      React.createElement('div', { style: styles.darkBlock, className: 'services-dark-block' },
        React.createElement('div', { style: styles.darkBlockInner, key: currentIndex, className: 'services-dark-block-inner' },
          React.createElement('div', { style: styles.serviceNum }, slide.num),
          React.createElement('h3', { style: styles.serviceTitle }, slide.title),
          React.createElement('p', { style: styles.serviceDesc }, slide.desc),
          React.createElement('a', { href: '#', style: styles.exploreBtn }, 'EXPLORE')
        ),
        React.createElement('button', { type: 'button', style: styles.arrowRight, onClick: goNext, 'aria-label': 'Next service', className: 'services-arrow-right' }, '›')
      )
    )
  );
}

export default ServicesSection;
